import { normalize } from 'normalizr';
import questionTypes from 'constants/questionTypes';
import courseSchema from '../schemas/course';

/* eslint-disable import/prefer-default-export */
export default {
  map: (data: any) => {
    const normalized: any = normalize(filterCourseData(data), courseSchema);
    const course: any = normalized.entities.course[normalized.result];
    const { sections, questions, contents } = normalized.entities;

    return {
      course,
      sections,
      questions,
      contents
    };
  }
};

function filterCourseData(data: any) {
  data.sections = data.sections.filter((section: any) => {
    section.questions = section.questions.filter((question: any) => questionTypes.includes(question.type));
    return section.questions.length > 0;
  });

  return data;
}
